import { call, put } from "redux-saga/effects";
import {
  moveToProcessPOSuccess,
  moveToProcessPOFailed,
  uploadToVendorPOSuccess,
  uploadToVendorPOFailed,
} from "./actions";
import { showErrorNotification } from "src/util/notifications";
import api from "src/util/api";
import {
  FTP_FILE_TRANSFER_URL,
} from "src/util/constants/api.constants";

export function* moveToProcessPO(action: any): Generator<any, void, any> {
  let url = FTP_FILE_TRANSFER_URL.MOVE_TO_PROCESSPO_URL;
  try {
    const response = yield call(api.post, url, action.payload);
    yield put(moveToProcessPOSuccess(response));
  } catch (error) {
    yield put(moveToProcessPOFailed(error));
    yield call(showErrorNotification, (error as any)?.message || 'Move to ProcessPO failed', error);
  }
}

export function* uploadToVendorPO({ payload }: any): Generator {
  let url = FTP_FILE_TRANSFER_URL.UPLOAD_TO_VENDORPO_URL + "/" + payload.VendorName;
  try {
    const formdata = new FormData();
    formdata.append("file", payload.file);
    const data: any = yield call(api.post, url, formdata);
    yield put(uploadToVendorPOSuccess(data));
  } catch (error) {
    yield put(uploadToVendorPOFailed(error));
    yield call(showErrorNotification, (error as any)?.message || 'Upload to VendorPO failed', error);
  }
}